import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import TransferOrderFileLine from '../entities/transfer-order-file-line';
import Ajax from '../../lib/ajax';
import util from '@/lib/util';
import appconst from '../../lib/appconst';
import _ from 'lodash';
import PageResult from '@/store/entities/page-result';

interface TransferOrderImportState extends ListState<TransferOrderFileLine> {
	itemsImported: Array<TransferOrderFileLine>;
	countItems: number;
	countImportedItems: number;
}
class TransferOrderImportModule extends ListModule<TransferOrderImportState, any, TransferOrderFileLine> {
	state = {
		totalCount: 0,
		currentPage: 1,
		pageSize: 10,
		list: new Array<TransferOrderFileLine>(),
		loading: false,
		itemsImported: new Array<TransferOrderFileLine>(),
		countItems: 0,
		countImportedItems: 0,
	};
	actions = {
		async getAll(context: ActionContext<TransferOrderImportState, any>, payload: any) {
			context.state.loading = true;
			const {
				data: { result },
			} = await Ajax.get('/api/services/app/ToFileLine/GetAll', { params: payload.data });
			context.state.loading = false;
			const page = result as PageResult<TransferOrderFileLine>;
			context.state.totalCount = page.totalCount;
			context.state.list = page.items;
		},
		async importTos(context: ActionContext<TransferOrderImportState, any>, data: any) {
			let reponse = await Ajax.post('/api/services/app/ToFile/ImportTos', data);
			return reponse.data.result;
		},
		async export(context: ActionContext<TransferOrderImportState, any>, payload: any) {
			window.open(`${appconst.remoteServiceBaseUrl}import/ExportImportTos/` + payload.data, '_blank');
		},
	};
	mutations = {
		setCurrentPage(state: TransferOrderImportState, page: number) {
			state.currentPage = page;
		},
		setPageSize(state: TransferOrderImportState, pagesize: number) {
			state.pageSize = pagesize;
		},
		setCountItems(state: TransferOrderImportState, count: number) {
			state.countItems = count;
		},
		setCountImportedItems(state: TransferOrderImportState, count: number) {
			state.countImportedItems = count;
		},
		processNotifier(state: TransferOrderImportState, payload: any) {
			if (payload.data != null) {
				if (payload.data.data != undefined && payload.data.data != null) {
					const toLines = payload.data.data as Array<TransferOrderFileLine>;
					state.list = toLines;
				}
				if (!util.isNull(payload.data.countLine) && payload.data.countLine > 0) {
					state.totalCount = payload.data.countLine as number;
					state.currentPage = 1;
				}
				if (payload.data.countTo != undefined && payload.data.countTo != null && payload.data.countTo > 0) {
					state.countItems = payload.data.countTo as number;
				}
				if (
					payload.data.toImported != undefined &&
					payload.data.toImported != null &&
					payload.data.toImported > 0
				) {
					state.countImportedItems = payload.data.toImported as number;
				}
			}
		},
		resetList(state: TransferOrderImportState) {
			state.itemsImported = new Array<TransferOrderFileLine>();
		},
		pageChangeItemsImported(state: TransferOrderImportState) {
			state.list = util.pagingItems(state.itemsImported, state.pageSize, state.currentPage);
		},
	};
}
const transferOrderImportModule = new TransferOrderImportModule();
export default transferOrderImportModule;
